<template>
  <div
    id="page-contaienr"
    class="overflow-hidden d-flex"
    ref="creatives-page"
  >
    <div
      v-if="isPageLoading"
      class="loader align-self-center mx-auto"
    />
    <template
      v-else
    >
      <articles-section />
      <div
        class="flex-grow-1 overflow-hidden"
      >
        <creatives-preview
          class="w-100 h-100"
          @setIsSidebarOpen="setIsSidebarOpen($event)"
          :is-sidebar-open="isSidebarOpen"
        />
      </div>
      <div
        class="display-properties-sidebar-container h-100 flex-shrink-0"
      >
        <display-properties-sidebar
          class="display-properties-sidebar"
          @setIsSidebarOpen="setIsSidebarOpen($event)"
          :is-sidebar-open="isSidebarOpen"
        />
      </div>
    </template>
  </div>
</template>
<script>
import {
  mapGetters, mapState, mapActions, mapMutations,
} from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';
import * as contentTypes from '@/modules/content/store/types';

import ArticlesSection from '@/modules/showcase/components/ArticlesSection/ArticlesSection';
import CreativesPreview from '@/modules/showcase/components/CreativesPreview';
import DisplayPropertiesSidebar from '@/modules/showcase/components/Sidebar/DisplayPropertiesSidebar';

export default {
  name: 'ShowcasePage',
  components: {
    ArticlesSection,
    CreativesPreview,
    DisplayPropertiesSidebar,
  },
  data() {
    return {
      isPageLoading: false,
      isSidebarOpen: false,
    };
  },
  computed: {
    ...mapState('campaigns', [
      'campaign',
    ]),
    ...mapState('content', [
      'isAddingNewAnnotation',
    ]),
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_MANAGED_CAMPAIGN,
    ]),
  },
  methods: {
    ...mapActions('campaigns', [
      campaignTypes.FETCH_CREATIVE_SIZES,
    ]),
    ...mapActions('content', [
      contentTypes.FETCH_CREATIVE_TEMPLATES,
      contentTypes.SET_SELECTED_CREATIVE_ID,
      contentTypes.REMOVE_CURRENT_ANNOTATION,
    ]),
    ...mapMutations('content', [
      contentTypes.TOGGLE_ANNOTATIONS,
    ]),
    async getCreativeTemplates() {
      const payload = {
        templateGroupId: this.campaign.templateGroupId,
        campaignId: this.campaign.id,
      };
      if (this.GET_IS_MANAGED_CAMPAIGN) delete payload.campaignId;
      else delete payload.templateGroupId;
      return await this.FETCH_CREATIVE_TEMPLATES(payload);
    },
    async setIsSidebarOpen(isOpen) {
      this.isSidebarOpen = isOpen;
      if (!isOpen) {
        if (this.isAddingNewAnnotation) this.REMOVE_CURRENT_ANNOTATION();
        this.TOGGLE_ANNOTATIONS(false);
      }
    },
  },
  async created() {
    this.isPageLoading = true;
    await this.FETCH_CREATIVE_SIZES();
    await this.getCreativeTemplates();
    this.isPageLoading = false;
  },
};
</script>
<style scoped lang="scss">
#page-contaienr {
  height: 100%;
}
.display-properties-sidebar-container {
  position: relative;
  width: 75px !important;
}
.display-properties-sidebar {
  position: absolute;
  right: 0;
}
</style>
